import axios from 'axios'

axios.defaults.withCredentials = true

export default {
  get: function (params) {
    return axios.get(`${window.apiURL}api/configuration`, { params })
  },
  now: function () {
    return axios.get(`${window.apiURL}api/now`)
  }
}



// WEBPACK FOOTER //
// ./src/services/configuration.js